<digihaven-scanner-input
    [items]="scanItems$ |async"
    [initialFocus]="false"
    [required]="true"
    (scanned)="onScanned($event)"
    (remove)="onRemoveScanItem($event)"
></digihaven-scanner-input>
